import { swap } from "utils/object";

export const signageIntentionsValues = {
  "Signage will be posted": true,
  "Signage will not be posted": false,
};

export const signageIntentionsTexts = swap(signageIntentionsValues);
